import { render, staticRenderFns } from "./WebinarAlert.vue?vue&type=template&id=23c31abc&"
import script from "./WebinarAlert.vue?vue&type=script&lang=js&"
export * from "./WebinarAlert.vue?vue&type=script&lang=js&"
import style0 from "./WebinarAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports